"use client";

import React from "react";
import { ModalContainer, ResponsiveModal, MODAL_IDS } from "@wtc/ui";
import { TicketUpdateForm } from "./TicketUpdateForm";
import type { AddUpdateModalData } from "@/lib/modals/data/legacy-modal-data";

/**
 * Global modal: add an update (comment / status note / work log) to a ticket.
 * Opened by the universal "Add update" action via
 * openModal(MODAL_IDS.tasks.addUpdate, { ticketId }) — data-payload pattern,
 * no DetailActionContext (GLOBAL_MODAL_NO_ACTION_CONTEXT).
 */
export function AddTicketUpdateModalContainer() {
  return (
    <ModalContainer<AddUpdateModalData> modalId={MODAL_IDS.tasks.addUpdate}>
      {({ isOpen, data, onClose }) => {
        const ticketId =
          data?.ticketId ?? (data?.item as { id?: string } | undefined)?.id;
        if (!isOpen || !ticketId) {
          return null;
        }
        const ticketNumber = (data?.item as { ticket_number?: number | string } | undefined)
          ?.ticket_number;
        return (
          <ResponsiveModal
            globalModalId={MODAL_IDS.tasks.addUpdate}
            open={isOpen}
            onOpenChange={(open) => !open && onClose()}
            title={`Add Update${ticketNumber ? ` — #${ticketNumber}` : ""}`}
            maxWidth="lg"
          >
            <TicketUpdateForm ticketId={ticketId} onSuccess={onClose} onCancel={onClose} />
          </ResponsiveModal>
        );
      }}
    </ModalContainer>
  );
}
